import React from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import background from '../../assets/background/auth_page.png';
import { ArrowLeft, SmarterVending } from '../../components/atoms/icons';

interface Props {
    children : React.ReactElement[] | React.ReactElement;
    title: string;
    description: string;
    onBack?: React.MouseEventHandler<HTMLButtonElement> | undefined
    askText?: [string, string] | undefined
    askLink?: string | undefined
}

function AuthContainer(props: Props) {
  const {
    children, title, description, onBack, askText, askLink,
  } = props;
  return (
    <div className="main-container">
      <div
        style={{
          backgroundImage: `url(${background})`,
        }}
        className="image-background"
      />
      <div className="second-container">
        <div className="left-container">
          <SmarterVending width={50} />
          <h3 className="fw-light text-white ms-3 m-0">Smarter Vending</h3>
        </div>
        <div className="right-container">
          <div className="content-container" style={{ paddingTop: title === 'Signup' ? '50px' : '100px' }}>
            <div className={onBack ? 'onBack-button' : 'd-none'}>
              <button onClick={onBack} type="button" className="border-0 bg-transparent">
                <ArrowLeft />
              </button>
            </div>
            <h2 className="fw-bolder">{title}</h2>
            <h6 className="description">{description}</h6>
            {children}
            {askText && askLink && (
            <p className="fz-14 position-absolute bottom-0 text-secondary">
              {askText[0]}
              <Link
                to={askLink}
                className="text-decoration-none color-primary fw-bold"
              >
                &nbsp;
                {askText[1]}
              </Link>
            </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

AuthContainer.defaultProps = {
  onBack: undefined,
  askLink: undefined,
  askText: undefined,
};

export default AuthContainer;
